import IonIcon from '@reacticons/ionicons'


type ModalCloseButtonProps = {
    closeModal?: () => void
}

function ModalCloseButton({ closeModal }: ModalCloseButtonProps) {
    return (
        <IonIcon
            className='modal-close-button'
            name="close-circle"
            onClick={closeModal}
        />
    )
}

export default ModalCloseButton